import './progressbar.scss'
import { ProgressBarProps } from "./type/progressbarProps";

const ProgressBar = (props: ProgressBarProps) => {
    let progressPercentage = 0;
    if (props.currentPercentage) {
        progressPercentage = props.currentPercentage;
        if (props.currentPercentage > 100) progressPercentage = 100;
        if (props.currentPercentage < 0) progressPercentage = 0;
    }
    
    return (
        <div>
            <div className='empty-progress-bar'>
                <div className='full-progress-bar' style={{ width: progressPercentage + '%' }}></div>
            </div>
        </div>
    )
}

export default ProgressBar;